import AnimatedLink from "../../ui/motion/AnimatedLink";
import SmallSquareLogo from "../../ui/logo/SquareLogo";

export default function ProductsFooter() {
    return (
        <footer className="position-relative" style={{background: '#0a0a14', minHeight: '200px'}}>
            {/* Gradient overlay for smooth transition from content */}
            <div
                className="position-absolute w-100"
                style={{
                    top: '-60px',
                    height: '60px',
                    background: 'linear-gradient(to bottom, transparent 0%, #0a0a14 100%)',
                    pointerEvents: 'none'
                }}
            />
            <div className="container pt-16 pb-10">
                <SmallSquareLogo width='80px' customRedirect='/produkt'/>
                <ul className="nav justify-content-center mb-5">
                    <li className="nav-item">
                        <AnimatedLink
                            className="nav-link px-6 pt-4 fs-11 link-secondary-light"
                            to='/polityka-prywatnosci'>Polityka prywatności
                        </AnimatedLink>
                    </li>
                    <li className="nav-item">
                        <AnimatedLink
                            className="nav-link px-6 pt-4 fs-11 link-secondary-light"
                            to='/regulamin'>Regulamin
                        </AnimatedLink>
                    </li>
                </ul>
                <p className='mb-0 pb-8 fs-12 fw-medium text-center text-secondary-light'>
                    <span className='text-success'>Masz pytanie?</span> kontakt@produkacja.pl
                </p>

                <div className='position-relative border-bottom'
                     style={{borderColor: 'rgba(42, 209, 103, 0.15) !important'}}/>
                <p className="mb-0 pt-8 fs-11 fw-medium text-center text-secondary-light">
                    © 2026 Produkacja | Wszelkie prawa zastrzeżone.
                </p>
            </div>
        </footer>
    );
}